<template lang="pug">
  v-row(justify='center')
    v-dialog(v-model='openModal' persistent='' max-width='400')
      v-form(ref="form" v-model="valid" lazy-validation) 
      v-card( style="text-align:center;padding:10px")
        v-card-title
          span(style="margin-left:-10px;margin-bottom:10px") EDIT 
        v-card-text()
          v-layout(row wrap style="margin-bottom:10px")              
              v-flex(xs4 sm12)
                  h3(style="text-align:left")  {{name}}
          v-layout(row wrap)              
              v-flex(xs7 sm12 style="margin-top:20px")
                  v-text-field(id="mjp-nohp" class="inputDefault" v-model='nohp' label="No Hp" :rules='[visitorRules.phone, visitorRules.required]' :counter='phoneNumLength' :maxlength='phoneNumLength')
              v-flex(xs7 sm12 style="margin-top:20px")
                  v-text-field(id="mjp-email" class="inputDefault" v-model='email' label="Email"  :rules="emailRules")
        v-card-actions(style="margin-top:10px")
          v-spacer
          v-btn(
            color="blue darken-1"
            text
            @click='handleClose()'
          ) Cancel
          v-btn(
            color="primary"
            style="width:30%"
            :disabled="!isPage1Complete"
            @click='actionSave'
          ) Update
</template>

<script>
import { mapState } from "vuex";

export default {

name:"ModalEditDataWaskat3",
props:['openModal','onClose','editWaskat3'],

 data () {
      return {
        phoneNumLength: 15,
        dialog: false,
        valid: true,
        name :"",
        nohp:"",
        email:"",
        emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      }
    },
  computed: {
    ...mapState(["API_URL",'visitorRules']),
    isPage1Complete: function () {
      return (
        !!this.nohp && !!this.email
      );
    },
  },
  methods: {
    handleClose(){
      this.nohp = this.editWaskat3.contact
      this.email = this.editWaskat3.email
      this.$emit("onClose", false)
    },
    actionSave(){
      this.$refs.form.validate();
      if(this.$refs.form.validate() === true) {
        const newData = {...this.editWaskat3,
        contact:this.nohp,
        email : this.email
        }
        setTimeout(() => {
           this.$emit( 'handleSaveData', newData );
          this.$emit("onClose", false)
        }, 300);
      }
    },
    showData(){
      this.name = this.editWaskat3.name
      this.nohp = this.editWaskat3.contact
      this.email = this.editWaskat3.email
    }
  },
}
</script>

<style>

</style>